<script setup>
// D39: one chip for a type's status, the same tint everywhere.
import {computed} from 'vue';
import {typeStatusChipClass, TYPE_STATUS_OPTIONS, typeStatusKey} from '~/utils/memberships';

const props = defineProps({
  type: {type: Object, required: true},
});
const label = computed(() => props.type.statusLabel
    || TYPE_STATUS_OPTIONS.find(o => o.key === typeStatusKey(props.type))?.label
    || '');
</script>

<template>
  <span class="tl-chip" :class="typeStatusChipClass(type)">
    <template v-if="type.archivedAt">Archived</template>
    <template v-else>{{ label }}</template>
  </span>
</template>
